import { render, staticRenderFns } from "./ApplicantEditInternalHistory.vue?vue&type=template&id=c2460bf2&"
import script from "./ApplicantEditInternalHistory.vue?vue&type=script&lang=js&"
export * from "./ApplicantEditInternalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports